var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 20.7144C31.7101 20.7144 32.2857 21.29 32.2857 22.0001C32.2857 22.6594 31.7894 23.2029 31.1499 23.2771L31 23.2858H13C12.2899 23.2858 11.7143 22.7102 11.7143 22.0001C11.7143 21.3407 12.2106 20.7973 12.85 20.723L13 20.7144H31Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0908 12.0909C21.5929 11.5888 22.407 11.5888 22.9091 12.0909C23.3726 12.5544 23.4083 13.2837 23.0161 13.7881L22.9091 13.9092L14.8193 22.0001L22.9091 30.0909C23.3726 30.5544 23.4083 31.2837 23.0161 31.7881L22.9091 31.9092C22.4456 32.3727 21.7163 32.4083 21.212 32.0162L21.0908 31.9092L12.0908 22.9092C11.6274 22.4457 11.5917 21.7164 11.9839 21.2121L12.0908 21.0909L21.0908 12.0909Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.3d91150274ee5084e8c73b981ec8c1c2.svg";
export { ForwardRef as ReactComponent };